module.exports = __webpack_public_path__ + "static/media/menu.800ed7fb.png";